// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PhotosList-positionRelative-Xu1Ec {
    position: relative;
}

.PhotosList-photoListBgImage-7UGjp {
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 100%;
    padding-top: 70%;
    border-radius: 4px;
    background-color: var(--secondary-gray-bg);
}

.PhotosList-displayGrid-P44QG {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 20px;
    margin-top: 30px;
}

.PhotosList-coverPhotoSection-_jEQz {
    color: var(--primary-foreground);
    font-size: 12px;
    background-color: var(--primary-gray-bg);
    display: inline-block;
    position: absolute;
    top: 8px;
    left: 8px;
    padding: 4px 6px;
    border-radius: 4px;
    height: 25px;
    text-align: center;
    line-height: 18px;
}

.PhotosList-tickIcon-brAvx {
    width: 11px;
    height: 8px;
    margin-right: 5px;
}

@media (max-width:1199px) and (min-width: 441px) {
    .PhotosList-displayGrid-P44QG {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media screen and (max-width: 440px) {
    .PhotosList-displayGrid-P44QG {
        grid-template-columns: 100%;
    }
}

/* ============================================= */

/* PHOTO ROW REDESIGN                            */

/* ============================================= */

.PhotosList-photoRowGrid-Wmunn {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 10px;
    margin: 0 36px;
    -webkit-box-align: stretch;
        -ms-flex-align: stretch;
            align-items: stretch;
}

.PhotosList-photoThumbWrap-o9Bv6 {
    position: relative;
    width: 100%;
    aspect-ratio: 11 / 9;
    border-radius: 10px;
    overflow: visible;
}

.PhotosList-photoThumbImg-jMnom {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #e5e7eb;
}

.PhotosList-photoRemoveBtn-Z9vhl {
    position: absolute;
    top: -8px;
    right: -8px;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: #fff;
    border: 1.5px solid #e5e7eb;
    color: #6b7280;
    font-size: 16px;
    line-height: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    cursor: pointer;
    padding: 0;
    -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
            box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
    -webkit-transition: background 0.15s, color 0.15s;
    transition: background 0.15s, color 0.15s;
    z-index: 2;
}

.PhotosList-photoRemoveBtn-Z9vhl:hover {
    background: #fee2e2;
    color: #ef4444;
    border-color: #fca5a5;
}

.PhotosList-photoAddMoreCard-gS1ar {
    width: 100%;
    aspect-ratio: 11 / 9;
    border-radius: 10px;
    border: 1.8px dashed #b3d4f5;
    background: #f7fbff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    gap: 6px;
    cursor: pointer;
    font-size: 12px;
    color: #6b7280;
    font-family: inherit;
    font-weight: 500;
    -webkit-transition: border-color 0.2s, background 0.2s;
    transition: border-color 0.2s, background 0.2s;
}

.PhotosList-photoAddMoreCard-gS1ar:hover {
    border-color: #2196F3;
    background: #eef6fe;
    color: #2196F3;
}

/* Máximo 5 fotos por fila; el resto se posiciona debajo */

@media (max-width: 1199px) and (min-width: 768px) {
    .PhotosList-photoRowGrid-Wmunn {
        grid-template-columns: repeat(4, 1fr);
    }
}

@media screen and (max-width: 767px) and (min-width: 441px) {
    .PhotosList-photoRowGrid-Wmunn {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media screen and (max-width: 440px) {
    .PhotosList-photoRowGrid-Wmunn {
        grid-template-columns: repeat(2, 1fr);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/PhotosList/PhotosList.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,wCAAwC;IACxC,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA,kDAAkD;;AAClD,kDAAkD;;AAClD,kDAAkD;;AAElD;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,cAAc;IACd,0BAAoB;QAApB,uBAAoB;YAApB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,cAAc;IACd,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,eAAe;IACf,UAAU;IACV,iDAAyC;YAAzC,yCAAyC;IACzC,iDAAyC;IAAzC,yCAAyC;IACzC,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,4BAA4B;IAC5B,mBAAmB;IACnB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,sDAA8C;IAA9C,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA,0DAA0D;;AAC1D;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ","sourcesContent":[".positionRelative {\n    position: relative;\n}\n\n.photoListBgImage {\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    width: 100%;\n    height: 100%;\n    padding-top: 70%;\n    border-radius: 4px;\n    background-color: var(--secondary-gray-bg);\n}\n\n.displayGrid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    grid-gap: 20px;\n    margin-top: 30px;\n}\n\n.coverPhotoSection {\n    color: var(--primary-foreground);\n    font-size: 12px;\n    background-color: var(--primary-gray-bg);\n    display: inline-block;\n    position: absolute;\n    top: 8px;\n    left: 8px;\n    padding: 4px 6px;\n    border-radius: 4px;\n    height: 25px;\n    text-align: center;\n    line-height: 18px;\n}\n\n.tickIcon {\n    width: 11px;\n    height: 8px;\n    margin-right: 5px;\n}\n\n@media (max-width:1199px) and (min-width: 441px) {\n    .displayGrid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media screen and (max-width: 440px) {\n    .displayGrid {\n        grid-template-columns: 100%;\n    }\n}\n\n/* ============================================= */\n/* PHOTO ROW REDESIGN                            */\n/* ============================================= */\n\n.photoRowGrid {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 10px;\n    margin: 0 36px;\n    align-items: stretch;\n}\n\n.photoThumbWrap {\n    position: relative;\n    width: 100%;\n    aspect-ratio: 11 / 9;\n    border-radius: 10px;\n    overflow: visible;\n}\n\n.photoThumbImg {\n    width: 100%;\n    height: 100%;\n    border-radius: 10px;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-color: #e5e7eb;\n}\n\n.photoRemoveBtn {\n    position: absolute;\n    top: -8px;\n    right: -8px;\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    background: #fff;\n    border: 1.5px solid #e5e7eb;\n    color: #6b7280;\n    font-size: 16px;\n    line-height: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    padding: 0;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);\n    transition: background 0.15s, color 0.15s;\n    z-index: 2;\n}\n\n.photoRemoveBtn:hover {\n    background: #fee2e2;\n    color: #ef4444;\n    border-color: #fca5a5;\n}\n\n.photoAddMoreCard {\n    width: 100%;\n    aspect-ratio: 11 / 9;\n    border-radius: 10px;\n    border: 1.8px dashed #b3d4f5;\n    background: #f7fbff;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    cursor: pointer;\n    font-size: 12px;\n    color: #6b7280;\n    font-family: inherit;\n    font-weight: 500;\n    transition: border-color 0.2s, background 0.2s;\n}\n\n.photoAddMoreCard:hover {\n    border-color: #2196F3;\n    background: #eef6fe;\n    color: #2196F3;\n}\n\n/* Máximo 5 fotos por fila; el resto se posiciona debajo */\n@media (max-width: 1199px) and (min-width: 768px) {\n    .photoRowGrid {\n        grid-template-columns: repeat(4, 1fr);\n    }\n}\n\n@media screen and (max-width: 767px) and (min-width: 441px) {\n    .photoRowGrid {\n        grid-template-columns: repeat(3, 1fr);\n    }\n}\n\n@media screen and (max-width: 440px) {\n    .photoRowGrid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"positionRelative": `PhotosList-positionRelative-Xu1Ec`,
	"photoListBgImage": `PhotosList-photoListBgImage-7UGjp`,
	"displayGrid": `PhotosList-displayGrid-P44QG`,
	"coverPhotoSection": `PhotosList-coverPhotoSection-_jEQz`,
	"tickIcon": `PhotosList-tickIcon-brAvx`,
	"photoRowGrid": `PhotosList-photoRowGrid-Wmunn`,
	"photoThumbWrap": `PhotosList-photoThumbWrap-o9Bv6`,
	"photoThumbImg": `PhotosList-photoThumbImg-jMnom`,
	"photoRemoveBtn": `PhotosList-photoRemoveBtn-Z9vhl`,
	"photoAddMoreCard": `PhotosList-photoAddMoreCard-gS1ar`
};
module.exports = ___CSS_LOADER_EXPORT___;
